import React, { useState, useEffect, useRef } from "react";
import Items from '../items/Items';
import { tipoArticulos} from "../../data/catalogos"


const descriptionEditorOptions = { height: 100 };

const LentesDeContacto = props => {
        return (
        <Items title="Lentes de contacto" typeId={tipoArticulos.LentesDeContacto} ></Items>
    );
}

export default LentesDeContacto;